import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import ConfirmSignUpSuccess from '../ConfirmSignUpSuccess';
import { MdError } from 'react-icons/md';

const SignUp = ({ formik, showPassword, showPopup, setShowPopup, togglePassword }) => {

    const signUpSuccessMessage = useSelector(state => state.auth.signUp.signUpSuccessMessage);

    return (
        <>
            {!showPopup &&
                <div className='container-signup'>
                    <div className='container-signup-img'>
                        <img src='https://6f3ebe2ff971707.cmccloud.com.vn/tour/wp-content/uploads/2021/12/banh-trang-cuon-thit-heo.jpg' alt="" />
                    </div>
                    <div className='wrap-signup'>
                        <form className='signup-form' onSubmit={formik.handleSubmit}>
                            <span className='signup-form-title'>Sign Up</span>

                            <div className='wrap-input'>
                                <input
                                    type="text"
                                    id='username'
                                    name='username'
                                    value={formik.values.username}
                                    onChange={formik.handleChange}
                                    className='input'
                                    placeholder="Username"
                                />
                                <label htmlFor="username" className='form-label'>Username</label>
                                {formik.errors.username &&
                                    (
                                        <div className='wrap-input-err'>
                                            <MdError className='validate-error-icon' />
                                            <span className="err-text">{formik.errors.username}</span>
                                        </div>
                                    )
                                }
                            </div>
                            <div className='wrap-input'>
                                <input
                                    type="email"
                                    id='email'
                                    name='email'
                                    value={formik.values.email}
                                    onChange={formik.handleChange}
                                    className='input'
                                    placeholder="Enter your email"
                                />
                                <label htmlFor="email" className='form-label'>Email</label>
                                {formik.errors.email &&
                                    (
                                        <div className='wrap-input-err'>
                                            <MdError className='validate-error-icon' />
                                            <span className="err-text">{formik.errors.email}</span>
                                        </div>
                                    )
                                }
                            </div>
                            <div className='wrap-input'>
                                <input
                                    type={showPassword ? "text" : "password"}
                                    id='password'
                                    name='password'
                                    value={formik.values.password}
                                    className='input'
                                    onChange={formik.handleChange}
                                    placeholder="Password"
                                />
                                <label htmlFor="password" className='form-label'>Password</label>
                                {formik.errors.password &&
                                    (
                                        <div className='wrap-input-err'>
                                            <MdError className='validate-error-icon' />
                                            <span className="err-text">{formik.errors.password}</span>
                                        </div>
                                    )
                                }
                            </div>
                            <div className='wrap-input'>
                                <input
                                    type={showPassword ? "text" : "password"}
                                    id='confirmPassword'
                                    name='confirmPassword'
                                    value={formik.values.confirmPassword}
                                    className='input'
                                    onChange={formik.handleChange}
                                    placeholder="Confirm Password"
                                />
                                <label htmlFor="confirmPassword" className='form-label'>Confirm password</label>
                                {formik.errors.confirmPassword &&
                                    (
                                        <div className='wrap-input-err'>
                                            <MdError className='validate-error-icon' />
                                            <span className="err-text">{formik.errors.confirmPassword}</span>
                                        </div>
                                    )
                                }
                            </div>
                            <div className='wrap-input'>
                                <input
                                    type="text"
                                    id='firstName'
                                    name='firstName'
                                    value={formik.values.firstName}
                                    onChange={formik.handleChange}
                                    className='input'
                                    placeholder='Enter your first name'
                                />
                                <label htmlFor="firstName" className='form-label'>First Name</label>
                                {formik.errors.firstName &&
                                    (
                                        <div className='wrap-input-err'>
                                            <MdError className='validate-error-icon' />
                                            <span className="err-text">{formik.errors.firstName}</span>
                                        </div>
                                    )
                                }
                            </div>
                            <div className='wrap-input'>
                                <input
                                    type="text"
                                    id='lastName'
                                    name='lastName'
                                    value={formik.values.lastName}
                                    onChange={formik.handleChange}
                                    className='input'
                                    placeholder='Enter your last name'
                                />
                                <label htmlFor="lastName" className='form-label'>Last Name</label>
                                {formik.errors.lastName &&
                                    (
                                        <div className='wrap-input-err'>
                                            <MdError className='validate-error-icon' />
                                            <span className="err-text">{formik.errors.lastName}</span>
                                        </div>
                                    )
                                }
                            </div>
                            <div className='show-password'>
                                <input type='checkbox'
                                    id='show-pass'
                                    checked={showPassword}
                                    onChange={togglePassword}
                                />
                                <label htmlFor='show-pass'>Show password</label>
                            </div>
                            <div className='signup-form-btn'>
                                <button type="submit" className='signup-btn'>Create Account</button>
                            </div>
                            <div className='signup-more'>
                                <ul>
                                    <li>
                                        <span className='txt1'> ⭐ Already have an account? <Link className='txt2' to='/auth/sign-in'>Sign in</Link></span>
                                    </li>
                                </ul>
                            </div>
                        </form>
                    </div>
                </div>}
            {showPopup && <ConfirmSignUpSuccess signUpSuccessMessage={signUpSuccessMessage} setShowPopup={setShowPopup} showPopup={showPopup} />}
        </>
    )
}
export default SignUp;